import React from "react";
import "./rented.scss";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "@iconify/react";
import {
  RentOffer,
  getMyNFTss,
  cancelRent,
} from "../../contractInteraction/contractInteraction";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { useAccount, useWalletClient } from "wagmi";
import { useState, useEffect } from "react";
import { firestoredb } from "../../../firebase/firebase";
import Modal from "react-bootstrap/Modal";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { toast } from "react-toastify";
import Swiper from "swiper";
const Rented = () => {
  const { address } = useAccount();
  const { data: signer } = useWalletClient();
  const [mynfts, setMynfts] = useState([]);
  const [currentTokenid, setCurrentTokenid] = useState("");
  const [show, setShow] = useState(false);
  const [found, setFound] = useState(false);

  const getMyPlot = async () => {
    setMynfts([]);
    if (address) {
      // var mylist=[]
      await getMyNFTss(address)
        .then((res) => {
          console.log("Original", res[0]);
          console.log("rented", res[1][0][0]);
          //Extra loop just to get coordinates as contract is not returning rented nfts' coordinate
          // let rentedCoordinate = [];
          // res[0].map(async (item, index) => {
          //   rentedCoordinate.push(item.coordinate);
          // }
          // )

          //Extra loop end

          // res[0].map(async (item, index) => {
          //   const mapnumber = item.coordinate.split("-")
          //   console.log(mapnumber[0]);
          //   const docRef = doc(firestoredb, "map", mapnumber[0]);
          //   await getDoc(docRef).then(res => {
          //     // mylist.push(res.data()[item.coordinate])
          //     setMynfts(prev => [...prev, { data: res.data()[item.coordinate], coordinate: item.coordinate,tokenId:item.tokenId }])
          //   }).catch(err => {
          //     console.log(err);
          //   })
          // })
          console.log("bros", res[1]);
          res[1].map(async (item, index) => {
            if (item.isActive) {
              setFound(true);
              // const mapnumber = item.coordinate.split("-")
              const mapnumber = item.coordinate.split("-");
              console.log(mapnumber.length > 0);
              const docRef = doc(firestoredb, "map", mapnumber[0]);
              await getDoc(docRef)
                .then((res) => {
                  // mylist.push(res.data()[item.coordinate])
                  setMynfts((prev) => [
                    ...prev,
                    {
                      data: res.data()[item.coordinate],
                      coordinate: item.coordinate,
                      tokenId: item.tokenId,
                    },
                  ]);
                  // console.log("Get NFT", item[0]);
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const settings = {
    infinite: false,
    dots: true,
    arrows: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 787,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1700,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  const handleCancelRent = async (tokenId, coordinate) => {
    console.log("Address", address);
    console.log("Token", tokenId);
    console.log("Coordinate", coordinate);
    const mapNumber = coordinate.split("-");
    console.log(mapNumber[0]);
    await cancelRent(address, Number(tokenId), signer)
      .then(async (res) => {
        console.log(res);
        if (res.success) {
          await setDoc(
            doc(firestoredb, "map", mapNumber[0]),
            {
              [coordinate]: {
                listRented: false,
              },
            },
            { merge: true }
          )
            .then((res) => console.log(res))
            .catch((err) => {
              console.log(err);
            });
          getMyPlot();
        }
      })
      .catch((err) => {
        console.log(err);
        getMyPlot();
      });
  };

  const rentedLand = [
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
    {
      landName: "Astral Citadel",
      size: "1X1",
      location: "28,000",
      expiry: "12:50pm",
      date: "12-07-23",
    },
  ];
  const rentCollection = [
    {
      landName: "Astra citadel",
      land: 28000,
      rent: 2240.5,
    },
    {
      landName: "Astra citadel",
      land: 28000,
      rent: 2240.5,
    },
    {
      landName: "Astra citadel",
      land: 28000,
      rent: 2240.5,
    },
    {
      landName: "Astra citadel",
      land: 28000,
      rent: 2240.5,
    },
    {
      landName: "Astra citadel",
      land: 28000,
      rent: 2240.5,
    },
  ];

  useEffect(() => {
    getMyPlot();
  }, [address]);


  return (
    <>
      <div className="rented-assets">
        <div className="left-wrapper">
          <div className="land-owner content-wrapper">
            <div className="left">
              <img src="\assets\images\Account-setting\profile.png" alt="" />
            </div>
            <div className="right">
              <h2>land owner</h2>
              <div className="owener-detail">
                <p>Shaki wilson</p>
                <p>shakiwilson3@astrality.com</p>
                <p>USER ID : willson.shaki4321</p>
                <p>Lands Owned: 07</p>
              </div>
            </div>
          </div>

          <div className="rentel-collected content-wrapper">
            <div className="rentel-collected-header">
              <h2 className="opacity-0">rental </h2>
              <h2>rental collected</h2>
              <p className="date">
                <img src="\assets\icons\date.svg" alt="" />
                21 jun-01 jul
              </p>
            </div>
            <div className="rented-table">
              <div className="rented-table-header">
                <p>land name</p>
                <p>land </p>
                <p>rent </p>
              </div>
              <div className="rented-table-body">
                {rentCollection.map((item, index) => {
                  return (
                    <div className="rented-table-body-content" key={index}>
                      <p>Astral Citadel</p>
                      <p className="text-light-green">28,200 </p>
                      <p>$ 2240.15 </p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="rental-income ">
              <p>
                <span>Total Rental Income</span>
                <span className="text-light-blue">$ 5123</span>
              </p>
            </div>
          </div>
        </div>
        <div className="right-wrapper">
          {/* rented land */}

          <div className="inventory-content rented-lands">
            <h2 className="cards-head">Rented Lands</h2>

            {address ? (
              <Slider {...settings}>
                {mynfts.length > 0 && found ?
                  mynfts.map((item, index) => {
                    const imageHtml = item.data.background.split("(");
                    return (
                      <div>
                        <div className="rented-land-card" key={index}>
                          <div className="card-header">
                            <img
                              src={imageHtml[1]}
                              alt="..."
                              className="card-top"
                            />
                          </div>
                          <div className="card-body">
                            <div className="name">
                              <p>{item.data.name}</p>
                              <p className="para d-flex">
                                <img
                                  src="\assets\images\Account-setting\locationIcon.svg"
                                  alt="land"
                                  className="img-fluid"
                                />
                                <span className="text-light-green mx-2">
                                  {item.coordinate}
                                </span>
                              </p>
                            </div>
                            <div className="location d-flex justify-content-between">
                              <p className="para">Size: {item.data.size}</p>
                              <p className="para">
                                <span className="text-light-green">
                                  Land Rented
                                </span>
                              </p>
                            </div>
                            <div className="button-wrapper d-flex g-10">
                              <button
                                onClick={() => {
                                  handleCancelRent(
                                    item.tokenId,
                                    item.coordinate
                                  );
                                }}
                                className="rentCancelButton"
                              >
                                Cancel Rent
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  }) : <span className="text-white text-center">You havn't rented any land</span>
                }
              </Slider>
            ) : (
              <ConnectButton />
            )}
          </div>

          {/* rental collected history */}

          {/* <div className="rentel-collected content-wrapper">
            <div className="rentel-collected-header">
              <h2 className="opacity-0">rental </h2>
              <h2>Rental collected History</h2>
              <p className="date">
                <img src="\assets\icons\date.svg" alt="" />
                21 jun-01 jul
              </p>
            </div>
            <div className="rented-table history-table">
              <div className="rented-table-header">
                <p>land name</p>
                <p>land </p>
                <p>rent </p>
              </div>
              <div className="rented-table-body">
                {rentCollection.map((item, index) => {
                  return (
                    <div className="rented-table-body-content" key={index}>
                      <p>Astral Citadel</p>
                      <p className="text-light-green">28,200 </p>
                      <p>$ 2240.15 </p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="rental-income ">
              <p>
                <span>Total Rental Income</span>
                <span className="text-light-blue">$ 5123</span>
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Rented;
